import { render } from "./EconomyListingsTables.vue?vue&type=template&id=3319aa84&ts=true"
import script from "./EconomyListingsTables.vue?vue&type=script&lang=ts"
export * from "./EconomyListingsTables.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__